<template>
  <div id="idPrincipal">
    <div v-if="!isNew && !blockStock" style="margin-bottom: 10px;">
      <div class="field ">
        <button class="ui basic button" v-on:click="addStock">
          <i :class="showStockOptions ? 'close icon' : 'add icon'"></i>
          Añadir Stock
        </button>
      </div>
    </div>

    <div v-if="!blockStock && showStockOptions" class="ui segment">
      <div class="field">
        <label v-if="flujoStock === 'E'">Almacén Destino</label>
        <label v-else>Almacén Origen</label>
        <sui-dropdown fluid search selection :options="storesOptions" v-model="selectStore" placeholder="Almacen" />
      </div>

      <div v-if="(flujoStock === 'E' && stockNamesOptions.length > 0) || (selectStore && stockNamesOptions.length > 0)">
        <div class="two fields aligned">
          <div class="field">
            <label>Repuestos</label>
            <sui-dropdown fluid search selection v-model="selectionStockName" :options="stockNamesOptions"
              placeholder="Nombre Repuestos" />
          </div>
          <div v-if="stockIdentifiersOptions.length > 0" class="field">
            <label style="visibility: hidden;">Identificadores</label>
            <sui-dropdown fluid search selection v-model="selectStockIdentifier" :options="stockIdentifiersOptions"
              placeholder="Indentificadores de Repuestos" />
          </div>
        </div>
      </div>

      <div
        v-if="(flujoStock === 'E' && columnNamesOptions.length > 0) || (selectStore && columnNamesOptions.length > 0)">
        <div class="two fields">
          <div class="field">
            <label>Columnas</label>
            <sui-dropdown fluid search selection v-model="selectionColumnName" :options="columnNamesOptions"
              placeholder="Nombre Columnas" />
          </div>
          <div v-if="columnIdentifiersOptions.length > 0" class="field">
            <label style="visibility: hidden;">Identificadores</label>
            <sui-dropdown fluid search selection v-model="selectColumnIdentifier" :options="columnIdentifiersOptions"
              placeholder="Identificadores de Columnas" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedOptions.length > 0" class="field">
      <form class="ui form">
        <table class="ui center aligned compact stackable table">
          <thead>
            <tr>
              <th v-if="flujoStock === 'E'">Almacen Destino</th>
              <th v-else>Almacen Origen</th>
              <th v-if="installed_columns">APM</th>
              <th>Nombre Stock</th>
              <th>ID</th>
              <th>ID Proveedor</th>
              <!-- <th>Cantidad</th> -->
              <th v-if="!blockStock && allowEdit"></th>
              <th v-if="!blockStock && actionTypeKey !== 'desinstalacion'"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="selection in selectedOptions" v-bind:key="selection.id">
              <td v-if="blockStock || flujoStock === 'S'"> {{ selection.store_name }} </td>
              <td v-if="!blockStock && flujoStock === 'E'">
                <sui-dropdown id="idaaa" fluid search selection :options="storesOptions" v-model="selection.store_id"
                  @input="changeStore(selection)" placeholder="Almacen" />
              </td>
              <td v-if="installed_columns"> {{ selection.apt_name }} </td>
              <td v -if <td>{{ selection.name }}</td>
              <td :id="'idPIP_' + selection.id"> {{ selection.product_identifier }} </td>
              <td :id="'idPI_' + selection.id"> {{ selection.product_identifier_prov }} </td>
              <!-- <td id="idQuantity" v-if="!selection.desglose && isNew">
                <i class="large minus circle icon" v-on:click="accion(selection, 'menos')"></i>
                <input class="inputQuantityNum" type="number" min="0" v-on:keyup="accion(selection, 'inputNumber')"
                  v-model="selection.quantitySelected" :id="'id_' + selection.id"
                  oninput="this.value = (this.value.replace(/[^0-9]/g, 0).replace('/(\..*?)\..*/g', 0)) ? this.value : 0;" />
                /
                {{ selection.quantity }}
                <i class="large plus circle icon" v-on:click="accion(selection, 'mas')"></i>
              </td>
              <td v-else>
                <p>Desglose{{ selection.desglose }}</p>
                <p>BlockStock{{ blockStock }}</p>
                <i v-if="!selection.desglose && !blockStock" class="large minus circle icon"
                  v-on:click="prueba(selection, 'menos')"></i>
                <b :id="'id_' + selection.id"> {{ selection.quantitySelected }} </b>
                <i v-if="!selection.desglose && !blockStock" class="large plus circle icon"
                  @click="prueba(selection, 'mas')"></i>
              </td> -->

              <td v-if="!blockStock && allowEdit">
                <div v-if="selection.desglose" :id="'idEdit_' + selection.id" v-on:click="showOptions(selection)">
                  <i class="large pencil alternate icon"></i>
                </div>

                <div :id="'idSave_' + selection.id" class="cEdit">
                  <div class="ui buttons">
                    <button class="ui red button" v-on:click="cancelUpdate(selection)"><i class="x icon"></i></button>
                    <div class="or"></div>
                    <button id="idBtnSave" class="ui positive button" v-on:click="saveUpdate(selection)"><i
                        class="check icon"></i></button>
                  </div>
                </div>
              </td>
              <td v-if="!blockStock && actionTypeKey !== 'desinstalacion'">
                <i class="large trash alternate outline icon" v-on:click="deleteOption(selection)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'selectStock',
  props: ['theIsNew', 'theBlockStock', 'theFlujoStock', 'theActionTypeKey', 'theStores', 'theStockNames', 'theColumnNames', 'theStockSelected', 'theLetAddItem', 'allowEdit'],
  data() {
    return {
      storesOptions: [],
      stockNamesOptions: [],
      stockIdentifiersOptions: [],
      columnNamesOptions: [],
      columnIdentifiersOptions: [],
      selectionStockName: null,
      selectStockIdentifier: null,
      selectionColumnName: null,
      selectColumnIdentifier: null,
      selectStore: null,
      selectedOptions: [],
      letAddItem: false,
      selectIdentifier: null,
      flujoStock: null,
      actionTypeKey: null,
      blockStock: false,
      showStockOptions: true,
      isNew: false,
      showBtnsMasMenos: false,
      installed_columns: false,
    }
  },
  mounted() {
    this.actionTypeKey = this.theActionTypeKey
    this.flujoStock = this.theFlujoStock
    this.stockNamesOptions = JSON.parse(JSON.stringify(this.theStockNames));
    this.columnNamesOptions = JSON.parse(JSON.stringify(this.theColumnNames));
    this.letAddItem = this.theLetAddItem
    this.storesOptions = JSON.parse(JSON.stringify(this.theStores))
    this.isNew = this.theIsNew
    if (!this.isNew) {
      this.blockStock = this.theBlockStock
      this.showStockOptions = false
    }

    if (this.theStockSelected) {
      this.selectedOptions = JSON.parse(JSON.stringify(this.theStockSelected));
      this.installed_columns = this.selectedOptions.some(a => a.apt_name !== '')
    }
  },
  watch: {
    'selectStore': function (new_store, old_store) {
      if (new_store) {
        this.selectStore = new_store
        if (this.flujoStock === 'S') {
          this.stockNamesOptions = this.theStockNames.filter((e) => e.store_id == new_store)
          this.columnNamesOptions = this.theColumnNames.filter((e) => e.store_id == new_store)
          this.stockIdentifiersOptions = []
          this.columnIdentifiersOptions = []
          this.resetSelection()

          if (this.selectedOptions.length > 0) {
            let new_combo = this.updateOptionsArray(this.stockNamesOptions);
            this.stockNamesOptions = new_combo;

            new_combo = this.updateOptionsArray(this.columnNamesOptions);
            this.columnNamesOptions = new_combo;
          }
        } else {
          this.selectedOptions.map((a) => {
            a.store_id = new_store
            a.store_name = this.storesOptions.find((e) => (e.value == new_store)).text
            return a
          })
        }
        this.$emit('stockSelected', this.selectedOptions);
      }
    },
    'selectionStockName': function (new_stock, old_stock) {
      if (new_stock) {
        let data = this.stockNamesOptions.find((e) => e.value == new_stock)
        this.stockIdentifiersOptions = []
        if (data.desglose) {
          this.stockIdentifiersOptions = data.identificadores
        } else {
          if (data.quantity > 0 || this.letAddItem) {
            this.selectedOptions.push(data.identificadores[0])
            this.selectionStockName = null
            this.editViewOption(data.identificadores[0])
          }
          if (!this.isNew) {
            this.showStockOptions = false
            this.selectStore = null
            this.resetSelection()
          }
          this.$emit('stockSelected', this.selectedOptions);
        }
      }
    },
    'selectStockIdentifier': function (new_identifier, old_identifier) {
      if (new_identifier) {
        let stockOption = this.stockNamesOptions.find((e) => e.identificadores.find((a) => a.value == new_identifier))
        if (stockOption.quantity > 0 || this.letAddItem) {
          stockOption.quantity = 1
          for (let i = 0; i < stockOption.identificadores.length; i++) {
            if (stockOption.identificadores[i].id == new_identifier) {
              const registroOriginalCombo = { ...stockOption.identificadores[i] }
              if (this.selectStore) {
                stockOption.identificadores[i].store_id = this.selectStore
                stockOption.identificadores[i].store_name = this.storesOptions.find((e) => (e.value == this.selectStore)).text
              }
              this.selectedOptions.push(stockOption.identificadores[i])
              this.editViewOption(registroOriginalCombo)
            }
          }
        }
        this.selectionStockName = null
        if (!this.isNew) {
          this.showStockOptions = false
          this.selectStore = null
          this.resetSelection()
        }
        this.$emit('stockSelected', this.selectedOptions);
      }
    },
    'selectionColumnName': function (new_stock, old_stock) {
      if (new_stock) {
        let data = this.columnNamesOptions.find((e) => e.value == new_stock)
        this.columnIdentifiersOptions = []
        if (data.desglose) {
          this.columnIdentifiersOptions = data.identificadores
        } else {
          if (data.quantity > 0 || this.letAddItem) {
            this.selectedOptions.push(data.identificadores[0])
            this.selectionColumnName = null
            this.editViewOption(data)
          }
          if (!this.isNew) {
            this.showStockOptions = false
            this.selectStore = null
            this.resetSelection()
          }
          this.$emit('stockSelected', this.selectedOptions);
        }
      }
    },
    'selectColumnIdentifier': function (new_identifier, old_identifier) {
      if (new_identifier) {
        let stockOption = this.columnNamesOptions.find((e) => e.identificadores.find((a) => a.value == new_identifier))
        if (stockOption.quantity > 0 || this.letAddItem) {
          stockOption.quantity = 1
          for (let i = 0; i < stockOption.identificadores.length; i++) {
            if (stockOption.identificadores[i].id == new_identifier) {
              const registroOriginalCombo = { ...stockOption.identificadores[i] }
              if (this.selectStore) {
                stockOption.identificadores[i].store_id = this.selectStore
                stockOption.identificadores[i].store_name = this.storesOptions.find((e) => (e.value == this.selectStore)).text
              }
              this.selectedOptions.push(stockOption.identificadores[i])
              this.editViewOption(registroOriginalCombo)
            }
          }
        }
        this.selectionColumnName = null
        if (!this.isNew) {
          this.showStockOptions = false
          this.selectStore = null
          this.resetSelection()
        }
        this.$emit('stockSelected', this.selectedOptions);
      }
    },
  },
  methods: {
    addStock() {
      this.showStockOptions = !this.showStockOptions;
    },
    fShowBtnsMasMenos() {
      this.showBtnsMasMenos = !this.showBtnsMasMenos
    },
    fBlockStock() {
      let x = document.getElementById("idBtnBlockStock");
      x.classList.add("loading");
      x.disabled = true;
      this.$emit('stockSelected', 'blockStock');
    },
    resetSelection() {
      this.selectionStockName = null;
      this.selectStockIdentifier = null;
      this.selectionColumnName = null;
      this.selectColumnIdentifier = null;
    },
    changeStore(data) {
      this.selectedOptions.map((a) => {
        if (a.stock_product_id == data.stock_product_id) {
          a.store_id = data.store_id
          a.store_name = this.storesOptions.find((e) => (e.value == data.store_id)).text
        }
        return a
      })
      this.$emit('stockSelected', this.selectedOptions)
    },
    saveUpdate(val) {
      let x = document.getElementById("idBtnSave");
      x.classList.add("loading");
      x.disabled = true;

      let idPI = document.getElementById('idPI_' + val.id)
      let inputPI = idPI.getElementsByTagName("input")
      this.updatePI = inputPI[0].value

      let data = {}
      data.id = val.stock_product_id,
        data.product_identifier_prov = this.updatePI,

        hapiickApi().post('/v1/stocks/products/edit', {
          admin_id: JSON.parse(localStorage.admin).id,
          data: data
        })
          .then(request => {
            x.classList.remove("loading");
            x.disabled = false;
            if (request.data.status === 'OK') {
              document.getElementById('idEdit_' + val.id).style.display = "initial";
              document.getElementById('idSave_' + val.id).style.display = "none";
              document.getElementById('idPI_' + val.id).innerHTML = this.updatePI;

              this.selectedOptions.map((a) => {
                if (a.stock_product_id == val.stock_product_id) {
                  a.product_identifier_prov = this.updatePI
                }
                return a
              })
            } else if (request.data.message.duplicated_key) {
              let msg = "El ID de proveedor '" + request.data.message.duplicated_key + "' ya esta asignado para otra columna en el sistema"
              this.$swal({
                type: 'error',
                title: 'Error al guardar los datos',
                text: msg
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Error saving data'
              });
            }
          })
          .catch(() => console.log('error update stock product'))
    },
    cancelUpdate(val) {
      document.getElementById('idEdit_' + val.id).style.display = "initial";
      document.getElementById('idSave_' + val.id).style.display = "none";
      document.getElementById('idPI_' + val.id).innerHTML = val.product_identifier_prov;
      document.getElementById('idObservations_' + val.id).innerHTML = val.observations;
      document.getElementById('idReciveDate_' + val.id).innerHTML = val.receive_date
      document.getElementById('idWarrantyDate_' + val.id).innerHTML = val.warranty_date
    },
    updateOptionsArray(optionsArray) {
      return optionsArray.map((aux) => {
        if (!aux.desglose) {
          const isInTable = this.selectedOptions.find((e) =>
            aux.id == e.stock_id && aux.store_id == e.store_id
          );
          return !isInTable ? aux : null;
        } else {
          const missingIdentifiers = aux.identificadores.filter((a) =>
            !this.selectedOptions.some((e) => e.stock_product_id == a.stock_product_id)
          );

          if (missingIdentifiers.length > 0) {
            aux.identificadores = missingIdentifiers;
            aux.text = `${aux.name} (${missingIdentifiers.length})`;
            return aux;
          } else {
            return null;
          }
        }
      }).filter(Boolean);
    },
    initializeComponent(stocks, columns) {
      this.letAddItem = this.theLetAddItem
      this.stockNamesOptions = stocks;
      this.columnNamesOptions = columns;
    },
    showOptions(val) {
      document.getElementById('idEdit_' + val.id).style.display = "none";
      document.getElementById('idSave_' + val.id).style.display = "initial";
      document.getElementById('idPI_' + val.id).innerHTML = "<input type='text' v-model='val.product_identifier_prov' value='" + val.product_identifier_prov + "' placeholder='ID Proveedor'/>";
    },
    cancelUpdate(val) {
      document.getElementById('idEdit_' + val.id).style.display = "initial";
      document.getElementById('idSave_' + val.id).style.display = "none";
      document.getElementById('idPI_' + val.id).innerHTML = val.product_identifier_prov;
    },
    editViewOption(option) {
      const comboOptions = option.stockType === 'R' ? [...this.stockNamesOptions] : [...this.columnNamesOptions];

      const filteredOptions = comboOptions.map(aux => {
        const clonedAux = { ...aux };
        if (clonedAux.id === option.stock_id && clonedAux.store_id === option.store_id) {
          clonedAux.identificadores = clonedAux.identificadores.filter(e => e.id !== option.stock_product_id);
          clonedAux.text = `${clonedAux.name} (${clonedAux.identificadores.length})`;
        }
        return clonedAux;
      });

      const newComboOptions = filteredOptions.filter(aux => aux.identificadores.length > 0);
      if (option.stockType === 'R') {
        this.stockNamesOptions = newComboOptions;
      } else {
        this.columnNamesOptions = newComboOptions;
      }

      this.stockIdentifiersOptions = []
      this.columnIdentifiersOptions = []
    },
    deleteOption(element) {
      this.resetSelection()

      element.quantitySelected = 1

      const origOptions = element.stockType === 'R' ? this.theStockNames : this.theColumnNames;
      const comboOptions = element.stockType === 'R' ? this.stockNamesOptions : this.columnNamesOptions;
      let nameExistInCombo = true
      let stock = null

      if (this.isNew) {
        if (this.flujoStock === 'E') {
          nameExistInCombo = comboOptions.some((e) => e.id == element.stock_id)
          if (nameExistInCombo) {
            comboOptions.find((e) => {
              if (e.id == element.stock_id) {
                e.identificadores.push(element)
                e.text = `${e.name} (${e.identificadores.length})`
              }
            })
          } else {
            stock = origOptions.find((e) => e.id == element.stock_id)
            stock.identificadores = []
            stock.identificadores.push(element)
            stock.text = `${stock.name} (${stock.identificadores.length})`
            comboOptions.push(stock)
          }
        } else {
          if (element.store_id == this.selectStore) {
            if (element.desglose) {
              nameExistInCombo = comboOptions.some((e) => e.id == element.stock_id && e.store_id == element.store_id)
              if (nameExistInCombo) {
                comboOptions.find((e) => {
                  if (e.id == element.stock_id && e.store_id == element.store_id) {
                    e.identificadores.push(element)
                    e.text = `${e.name} (${e.identificadores.length})`
                  }
                })
              } else {
                stock = origOptions.find((e) => e.id == element.stock_id && e.store_id == element.store_id)
                stock.identificadores = []
                stock.identificadores.push(element)
                stock.text = `${stock.name} (${stock.identificadores.length})`
                comboOptions.push(stock)
              }
            } else {
              let resetStock = origOptions.find(e => e.id == element.stock_id && e.store_id == element.store_id);
              comboOptions.push(resetStock);
            }
          }
        }
      }
      this.selectedOptions = this.selectedOptions.filter(item => item.stock_product_id != element.stock_product_id)
      this.$emit('stockSelected', this.selectedOptions);
    },
    accion(data, accion) {
      let inputQuantity = document.getElementById('id_' + data.id)

      if (accion === 'mas') {
        if (inputQuantity.value < data.quantity || this.letAddItem) {
          inputQuantity.value++
        }
      } else if (accion === 'menos') {
        if (inputQuantity.value > 1 || this.letAddItem) {
          inputQuantity.value--
        }
      } else {
        if (inputQuantity.value) {
          if (inputQuantity.value > data.quantity && !this.letAddItem) {
            inputQuantity.value = data.quantity
          } else {
            inputQuantity.value
          }
        } else {
          return
        }
      }

      let aux = this.selectedOptions.map((a) => {
        if (a.id == data.id) {
          a.quantitySelected = parseInt(inputQuantity.value)
        }
        return a
      })

      this.selectedOptions = []
      this.selectedOptions = aux
      this.$emit('stockSelected', this.selectedOptions);
    },
    prueba(data, accion) {
      this.showBtnsMasMenos = true
      let quantitySelected = parseInt(document.getElementById('id_' + data.id).innerHTML)
      let availabilityStock = parseInt(document.getElementById('idAS_' + data.id).innerHTML)
      let quantity = data.quantity

      if (accion === 'mas') {
        if (data.quantity > 0 || this.letAddItem) {
          if (quantitySelected >= data.quantitySelected_orig) {
            availabilityStock++
            quantity = data.quantity - 1
          }
          quantitySelected = quantitySelected + 1
        }
      } else if (accion === 'menos') {
        if (quantitySelected > 1 || this.letAddItem) {
          if (quantitySelected > data.quantitySelected_orig) {
            availabilityStock--
            quantity = data.quantity + 1
          }
          quantitySelected = quantitySelected - 1
        }
      } else {
        return
      }

      let aux = this.selectedOptions.map((a) => {
        if (a.id == data.id) {
          a.quantity = parseInt(quantity)
          a.quantitySelected = parseInt(quantitySelected)
        }
        return a
      })

      this.selectedOptions = []
      this.selectedOptions = aux
      this.$emit('stockSelected', this.selectedOptions);
    },
  },
}
</script>
<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

#idQuantity {
  align-items: center !important;
  display: inline-flex !important;
}

.inputQuantityNum {
  width: 50px !important;
  text-align: center;
}

.cEdit {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/selectStock.vue